<template>
    <BaseLink
        :to="link.linkPath"
        :tabindex="isTabbable ? 0 : -1"
        class="c-view-all-tile o-flex-vertical-center o-flex-horizontal-center"
    >
        <span
            :class="{
                'c-view-all-tile__text o-text--link': true,
                'c-view-all-tile__text--small o-text--caption': isSmall,
            }"
        >
            {{ link.linkTitle }}
        </span>
        <BaseIcon
            icon="global--right-arrow"
            :size="`${size}px`"
            color="primary"
            class="c-view-all-tile__right-arrow"
        />
    </BaseLink>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    link: {
        type: Object,
        required: true,
    },
    isTabbable: {
        type: Boolean,
        default: true,
    },
    isSmall: {
        type: Boolean,
        default: false,
    },
});

const size = computed(() => (props.isSmall ? 12 : 16));
</script>

<style lang='scss'>
    .c-view-all-tile {
        width: 100%;
        height: 100%;
        background-color: $placeholder-background;
        position: relative;

        &__text {
            margin-right: $nu-spacer-1;

            &--small {
                margin-top: $nu-spacer-0pt5;
                margin-right: $nu-spacer-0pt5;
            }
        }

        &__right-arrow {
            margin-right: $nu-spacer-1;
        }
    }
</style>
